<template>
  <div class="flex flex-col items-center justify-center h-screen">
    <img
      src="https://storage.googleapis.com/komerce/assets/logo/logo-komerce-no-tag.svg"
      alt="logo"
      width="176px"
      class="mb-[40px]"
    >
    <h1 class="text-2xl font-semibold text-center">
      Integrasi Marketplace Berhasil 🎉
    </h1>
    <p class="text-sm text-gray-500 text-center mb-[40px] max-w-[500px]">
      Sekarang Toko mu telah terintegrasi dengan sistem Komerce. Lakukan mapping produk dengan produk di Tokomu agar produkmu tersinkronisasi dengan sistem Kompack.
    </p>
    <p class="text-sm text-gray-500 text-center max-w-[500px]">
      Halaman akan tertutup otomatis dalam <span class="font-semibold">{{ countdown }}</span> detik.
    </p>
    <p class="text-sm text-gray-500 text-center max-w-[500px]">
      Apabila setelah hitung mundur selesai halaman tidak tertutup otomatis, silahkan tutup halaman ini secara manual.
    </p>
  </div>
</template>

<script>
export default {
  name: 'IntegratedSuccesfullyPage',
  data() {
    return {
      countdown: 3,
      sent: false,
    }
  },
  mounted() {
    this.startCountdown()
  },
  methods: {
    /**
     * Check if running in a popup window vs a full browser tab.
     * @returns {boolean}
     */
    isPopupWindow() {
      if (typeof window === 'undefined') return false

      if (!window.opener || window.opener === window || window.opener.closed) {
        return false
      }

      // Check for hidden browser chrome (typical of popups)
      const hasHiddenChrome = Boolean(
        (window.toolbar && !window.toolbar.visible)
        || (window.menubar && !window.menubar.visible)
        || (window.locationbar && !window.locationbar.visible)
        || (window.personalbar && !window.personalbar.visible),
      )
      if (hasHiddenChrome) return true

      // Check if window size is noticeably smaller than available screen
      const isSmallerThanScreen = (
        (window.outerWidth && window.outerWidth < window.screen.availWidth * 0.9)
        || (window.outerHeight && window.outerHeight < window.screen.availHeight * 0.9)
      )
      if (isSmallerThanScreen) return true

      return false
    },
    /**
     * Start countdown timer to close window or redirect to dashboard.
     */
    startCountdown() {
      const interval = setInterval(() => {
        this.countdown -= 1
        if (this.countdown <= 0) {
          clearInterval(interval)
          this.finishIntegration()
        }
      }, 1000)
    },
    /**
     * Broadcast success and close popup or navigate to integration dashboard.
     */
    finishIntegration() {
      if (this.sent) return
      this.sent = true

      const isChildWindow = this.isPopupWindow()

      try {
        const bc = new BroadcastChannel('marketplace_integration')
        bc.postMessage({
          type: 'INTEGRATION_SUCCESS',
          data: {
            source: isChildWindow ? 'popup' : 'tab',
          },
        })
        bc.close()
      } catch (e) {
        console.error('BroadcastChannel error:', e)
      }

      if (isChildWindow) {
        try {
          window.close()
        } catch (e) {
          this.$router.replace({ name: 'integrasi-marketplace' })
        }
      } else {
        this.$router.replace({ name: 'integrasi-marketplace' })
      }
    },
  },
}
</script>
